// The package has no root export: /lib/sdk is the only entry in its exports map
// that both webpack 5 and tsc (moduleResolution "node") can resolve.
import * as jam from '@jam.dev/recording-links/lib/sdk';
import { useEffect } from 'react';

interface JamInitOptions {
  teamId: string;
}

// jam's recorder reads these off the landing URL, so they must survive redirects.
export const isJamParam = (key: string) => key.startsWith('jam-');

export const useJam = ({ teamId }: JamInitOptions) => {
  useEffect(() => {
    if (teamId) {
      jam.initialize({ teamId });
    }
  }, []);
};
